import { gql } from '@apollo/client';

export const activateProvider = gql`
  mutation activateProvider($providerId: String!) {
    salesforce {
      activateProvider(providerId: $providerId)
    }
  }
`;

export const deactivateProvider = gql`
  mutation deactivateProvider(
    $providerId: String!
    $deactivateProviderInput: DeactivateProviderInput!
  ) {
    salesforce {
      deactivateProvider(
        providerId: $providerId
        deactivateProviderInput: $deactivateProviderInput
      )
    }
  }
`;

export const updateProvider = gql`
  mutation updateProvider(
    $providerId: String!
    $updateProviderInput: UpdateProviderInput!
  ) {
    salesforce {
      updateProvider(
        providerId: $providerId
        updateProviderInput: $updateProviderInput
      )
    }
  }
`;
